import { useSaleCompStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";

const useSaleCompDelete = (): (id: number) => Promise<void> => {
    const saleCompStore = useSaleCompStore();

    return async (id: number): Promise<void> => {
        try {
            await saleCompStore.deleteSaleComp(id);
            showSuccessToast();
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useSaleCompDelete;